var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { isLoading: _vm.createWishlistIsLoading } },
    [
      _vm.isLoggedIn
        ? [
            !_vm.hasWishlists ? [_vm._m(0)] : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "list-group",
                class: { "wishlist-overview": _vm.overview },
              },
              [
                !_vm.overview
                  ? _vm._l(_vm.lists, function (list) {
                      return _c(
                        "li",
                        {
                          key: list.id,
                          staticClass:
                            "list-group-item d-flex align-items-center",
                          class: [
                            "wishlist_design_" + list.colorScheme,
                            { activated: _vm.isOnWishlist(list.id) },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.toggleVariationWishlist(list.id)
                            },
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn mr-2 openListBtn",
                              attrs: {
                                href: "/wunschliste/" + list.accessCode + "/",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-pencil" })]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(list.name))]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("(" + _vm._s(_vm.numOnList(list.id)) + ")"),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "HeartAnimation",
                            class: { animate: _vm.isOnWishlist(list.id) },
                          }),
                        ]
                      )
                    })
                  : _vm._l(_vm.lists, function (list) {
                      return _c(
                        "li",
                        {
                          key: list.id,
                          class: "wishlist_design_" + list.colorScheme,
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "/wunschliste/" + list.accessCode + "/",
                              },
                            },
                            [
                              _c("span", { staticClass: "listInfo" }, [
                                _c("strong", [_vm._v(_vm._s(list.name))]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "(" + _vm._s(_vm.numOnList(list.id)) + ")"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "svg",
                                {
                                  staticClass: "css-i6dzq1",
                                  attrs: {
                                    viewBox: "0 0 24 24",
                                    width: "24",
                                    height: "24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    fill: "none",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("polyline", {
                                    attrs: { points: "9 18 15 12 9 6" },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                _vm._v(" "),
                _vm.createWishlistIsLoading
                  ? _c("li", { staticClass: "newListLoading" }, [_vm._m(1)])
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.canCreateNewWishlist
              ? _c(
                  "a",
                  {
                    staticClass: "createNew",
                    on: {
                      click: function ($event) {
                        return _vm.createNewWishlist()
                      },
                    },
                  },
                  [_vm._v("\n      Neue Liste anlegen\n    ")]
                )
              : _vm._e(),
          ]
        : [
            _c("p", { staticClass: "text-center" }, [
              _c("i", [
                _vm._v("Um Ihre Wunschlisten zu öffnen oder zu erstellen, "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-sm btn-bkm-inverted",
                    on: {
                      click: function ($event) {
                        return _vm.openLoginRegistration()
                      },
                    },
                  },
                  [_vm._v("melden Sie sich bitte an.")]
                ),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text-center text-muted my-3" }, [
      _c("i", [
        _vm._v(
          "\n          Sie haben noch keine Wunschliste angelegt\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("i", { staticClass: "fa fa-spin fa-circle-o-notch mr-2" }),
      _vm._v(" Wird geladen"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }